/**
 * Builds Postgres search request payloads for the external PA orders worklist from UI filters.
 */

import { SearchForMedicalPaOrdersFromPostgresParams } from "../../../../../api/postgreSQL/postCalls/searchForMedicalPaOrdersFromPostgres";
import { FilterValues } from "../../../../../data-model/filterValues";
import {
  processFilterData,
  transformDateFields,
  transformObjectToFacetFiltersForPostgres,
} from "../../../../../utils/queryConstraint";

const HITS_PER_PAGE = 100;

/**
 * Builds a Postgres search payload from the active filters, search term, and org ID.
 * Processes filter values into facet filter format and extracts date-range constraints.
 *
 * @param validFilters - Active filter values for the external PA orders table
 * @param searchTerm - Free-text search query
 * @param orgId - Organization/facility ID to scope the search
 * @returns A fully formed search payload ready for the Postgres search API
 */
export const generateFilterPayloadForExternalOrders = (
  validFilters: FilterValues[],
  searchTerm: string,
  orgId: string,
): SearchForMedicalPaOrdersFromPostgresParams => {
  const filterData = processFilterData(validFilters);
  const createdFilterQuery =
    transformObjectToFacetFiltersForPostgres(filterData);
  const dateFilterQuery = transformDateFields(filterData);

  return {
    org_id: orgId || "",
    query: searchTerm ?? "",
    facet_filters: createdFilterQuery,
    hits_per_page: HITS_PER_PAGE,
    page: 0,
    date_of_work_only: true,
    ...dateFilterQuery,
  };
};
